import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { buscarMesasAbertas } from '../../services/api';
import Carregando from '../../components/Carregando/Carregando';

// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./DashboardMesasAbertas.css";
import '../../styles/global.css';

const DashboardMesasAbertas = () => {

    const navigate = useNavigate();
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const BASE_URL = JSON.parse(sessionStorage.getItem('BASE_URL'));

    const [mesas, setMesas] = useState([]);
    const [carregando, setCarregando] = useState(true); 

    useEffect(() => {
        console.log('--- ENTROU EM DASHBOARD MESAS ABERTAS ----');
    
        const intervalId = setInterval(() => {
            console.log('Verificando se usuário está logado...');
            
            if (userData) {
                try {
                    if (userData.statusUsuario === 'logado') {
                        console.log('Sim, logado!');
                        const idEstabelecimento = userData.dadosEstabelecimento.id;
                        const dadosEnviar = {
                            idEstabelecimento: idEstabelecimento
                        };
                        console.log('Id do estabelecimento: ');
                        console.log(idEstabelecimento);

                        console.log('Dados enviar: ');
                        console.log(dadosEnviar);

                        console.log('Vamos chamar o fetch... ');

                        // buscar todos os checkins com contas em aberto
                        fetchMesasAbertas(dadosEnviar);

                    } else {
                        console.log('Usuário não está logado, mantendo na área restrita.');
                    }
                } catch (error) {
                    console.error('Erro ao parsear os dados de usuário:', error);
                }
            } else {
                console.log('Usuário NÃO está logado!');
            }
        }, 10000); // 10 segundos
    
        return () => clearInterval(intervalId);
    }, [userData]); // Dependência importante, para garantir que userData esteja atualizado


    const fetchMesasAbertas = async (dadosEnviar) => {
        // setCarregando(true);

        console.log('Entrou em fetchMesasAbertas em DashboardMesasAbertas');
        console.log(dadosEnviar);

        try {
            const dados = await buscarMesasAbertas(dadosEnviar);

            console.log('*** mesas abertas: ***', dados.mesas);

            if (dados?.mesas) {
                // vamos setar em checkins, os checkins que vieram
                setMesas(dados.mesas);
            }
            setCarregando(false);
        } catch (error) {
            console.error('Erro ao buscar as mesas abertas:', error);
            setCarregando(false);
        }
        
    }


    if (carregando) {
        return <Carregando />;
    }

    return (
        <div className="form-cadastrar-container">
            <TituloComponent />
    
            <form>
                <h2 className="form-title">Dashboard Mesas Abertas</h2>
    
                <div className="box-dados">
                    <p className="texto-welcome">
                        Você está em {userData.dadosEstabelecimento.nome}!
                    </p>
                </div>
    
                {/* Container de quadros */}
                <div className="quadros-container">
                    {Object.values(mesas || {}).map((mesa, indexMesa) => (
                        console.log('Mesa: '),
                        console.log(mesa),

                        mesa.totalMesa
                        ?

                            <div key={indexMesa} className="quadro">
                                <h3>Mesa {mesa.numero_mesa}</h3>
        
                                {Object.values(mesa.comandas || {}).map((comanda, indexComanda) => (
                                    <div key={indexComanda} style={{ marginBottom: '10px' }}>
                                        <p>
                                            Comanda {comanda.numero_comanda}: R$ {Number(comanda.totalComanda).toFixed(2)}
                                        </p>
                                    </div>
                                ))}
        
                                <p>
                                    <strong>TOT. MESA:</strong> R$ {Number(mesa.totalMesa).toFixed(2)}
                                </p>
                            </div>
                        :
                            <>
                                <p>
                                    <strong>Total Geral:</strong> R$ {Number(mesa).toFixed(2)}
                                </p>
                            </>
                    ))}
                </div>
            </form>
    
            <div className="mt-4"></div>
        </div>
    );
        
    
};

export default DashboardMesasAbertas;
